import * as api from "../Api/index";

// ! create actual budget

export const getAllUsers = () => async (dispatch) => {
  try {
    const { data } = await api.getUsers();
    dispatch({ type: "GET_ALL_USER", payload: data });
  } catch (error) {}
};
export const createUsers = (formData) => async (dispatch) => {
  try {
    const { data } = await api.signup(formData);
    dispatch({ type: "CREATE_FRESH_USER", payload: data });
  } catch (error) {}
};
export const updateUser = (id, postData) => async (dispatch) => {
  try {
    const { data } = await api.updateUser(id, postData);
    dispatch({ type: "UPDATE_SELECTED_USER", payload: data });
  } catch (error) {}
};
export const deleteUser = (id) => async (dispatch) => {
  try {
    await api.deleteUser(id);
    dispatch({ type: "DELETE_SELECTED_USER", payload: id });
  } catch (error) {}
};
